// @flow

import type { EftBankList, PaymentOption } from './types';
import type { CheckoutPaymentOptionsV2 } from '@tectonics/prs/incoming-payment';

export function getSafeEftPaymentOption(paymentOptions: ImmutableArray<PaymentOption> | CheckoutPaymentOptionsV2): EftBankList {
  if (!Array.isArray(paymentOptions) && Array.isArray(paymentOptions.eft_bank_list)) {
    return paymentOptions.eft_bank_list;
  }

  const paymentOption = Array.isArray(paymentOptions) && paymentOptions.find(paymentOption => paymentOption.id === 'eft');

  if (!paymentOption)
    throw new Error('Payment options: there is no `EFT` in available options list');

  if (paymentOption.id !== 'eft')
    throw new Error(`Payment options: obtained payment option "${paymentOption.id}" is not EFT`);

  return paymentOption.bank_list;
}
